var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm-icons / Navigation / Arrow-right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.3,
    x: 5,
    y: 13.2634,
    width: 2,
    height: 14,
    rx: 1,
    transform: "rotate(-90 5 13.2634)",
    fill: "url(#paint0_linear_1395_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 94",
    d: "M11.2929 17.5563C10.9024 17.9468 10.9024 18.5799 11.2929 18.9705C11.6834 19.361 12.3166 19.361 12.7071 18.9705L18.7071 12.9705C19.0857 12.5919 19.0989 11.9823 18.7372 11.5876L13.2372 5.58764C12.864 5.18052 12.2314 5.15302 11.8243 5.52621C11.4172 5.89941 11.3897 6.53197 11.7628 6.93909L16.6159 12.2333L11.2929 17.5563Z",
    fill: "url(#paint1_linear_1395_3078)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_3078",
    x1: 5.12222,
    y1: 13.2634,
    x2: 9.06963,
    y2: 13.9356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1395_3078",
    x1: 19,
    y1: 18.4078,
    x2: 7.91691,
    y2: 13.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-right.9817a60c064c98b0d875935758cda101.svg";
export { ForwardRef as ReactComponent };